if (!window.__addonCardClickableBound) {
  window.__addonCardClickableBound = true;

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-addon-card-clickable]');
    if (!card) return;

    if (event.target.closest('a, button, input, select, textarea, label, summary, [role="button"]')) return;

    var triggerButton = card.querySelector('[data-customise-trigger][data-submit-button]');
    if (!triggerButton) return;

    event.preventDefault();
    triggerButton.click();
  });
}
